import { Component, OnInit } from "@angular/core";
import { AppCommonService } from "../app-common.service";
import { Router } from "@angular/router";
import { SessionStorage } from 'ngx-webstorage';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: "app-sidebar",
  templateUrl: "./sidebar.component.html",
  styleUrls: ["./sidebar.component.scss"],
})
export class SidebarComponent implements OnInit {
  @SessionStorage('auth') public user: any;
  public modules: any;
  constructor(
    private appCommonService: AppCommonService,
    private router: Router,
    private snackBar: MatSnackBar
  ) { }

  ngOnInit(): void {
    this.getModules();
  }
  // get all modules based on login
  getModules() {
    this.appCommonService.login('user/getUserModules', {}).subscribe((response) => {
      if (response.success && response.payload) {
        response.payload.forEach(element => {
          if (element.modulename === 'Dashboard') {
            element.routeLink = '/dashboard';
            element.identifier = 'dashboard';
          } else if (element.modulename === 'Leads') {
            element.routeLink = '/leadmanagement';
            element.identifier = 'leadmanagement';
          } else if (element.modulename === 'Manage Role' || element.modulename === 'Manage Roles') {
            element.routeLink = '/rolemanagement';
            element.identifier = 'rolemanagement';
          } else if (element.modulename === 'Manage User') {
            element.routeLink = '/usermanagement/listusers';
            element.identifier = 'usermanagement';
          } else if (element.modulename === 'User Report' || element.modulename === 'User Reports') {
            element.routeLink = '/reports';
            element.identifier = 'reports';
          }
        });
        this.modules = response.payload;
      } else {
        this.snackBar.open((response.error && response.error.message ? response.error.message : window['serverError']), 'okay', { duration: 2000, verticalPosition: 'top', horizontalPosition: 'center' });
      }
    }, (err) => {
      this.snackBar.open((err.error && err.error.message ? err.error.message : window['serverError']), 'okay', { duration: 2000, verticalPosition: 'top', horizontalPosition: 'center' });
    })
  }
  checkActiveRoute(identifier: string) {
    const active = this.router.url.indexOf(identifier) === -1 ? false : true;
    return active;
  }
}
